import { render, staticRenderFns } from "./dashboardPage.vue?vue&type=template&id=a7273f26"
import script from "./dashboardPage.vue?vue&type=script&lang=js"
export * from "./dashboardPage.vue?vue&type=script&lang=js"
import style0 from "./dashboardPage.vue?vue&type=style&index=0&id=a7273f26&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports